import { useEffect, useState } from "react";

interface IMetadataSearchProps {
  opsArray: any[],
  setIsSearched: (key: boolean) => void,
  setFilteredArray: (key: any[]) => void,
  showQuickSearch: any,
  filterableMetaDataId: number
}
const MetadataQuickSearch = (props: IMetadataSearchProps) => {
  const [searchedText, setSearchedText]= useState("")

  useEffect(() => {
    setSearchedText("") //Clearing search field when changing the filterableMetaDataId
    props.setIsSearched(false); //Setting default array
  }, [props.filterableMetaDataId])

  const filterAggricates = (val: string) => {
    const unFilteredData: any[] = props.opsArray || [];
    setSearchedText(val)
    if (!val) {
      props.setIsSearched(false);
      props.setFilteredArray(unFilteredData); // reset to original
      return;
    } else {
      props.setIsSearched(true);
    }

    const search = val.toLowerCase();

    const filtered = unFilteredData.filter(item =>
      (item.BPValue && item.BPValue.toString().toLowerCase().includes(search)) ||
      (item.Name && item.Name.toLowerCase().includes(search)) ||
      (item.Description && item.Description.toLowerCase().includes(search)) ||
      (item.name && item.name.toLowerCase().includes(search)) ||
      (item.DisplayText && item.DisplayText.toLowerCase().includes(search)) ||
      (item.description && item.description.toLowerCase().includes(search))
    );
    props.setFilteredArray(filtered);
  };

  return (
    <div className="quick-search">
      <div id="vu_popup_filter_search_wrapper" style={{ display: props.showQuickSearch ? "block" : "none" }} className="search-text-wrapper">
        <img src="../images/search.png" alt="" className="search-image" />
        <input value={searchedText} placeholder="search..." type="text" id="vu_params_filtervalue_search_text" onChange={(e) => filterAggricates(e.target.value)} name="vu_params_filtervalue_search_text" className="input-text" />
        {/* <span className="placeholder-text">search...</span> */}
      </div>
    </div>
  )
}

export default MetadataQuickSearch